import React, { useState } from "react";
import "./ModalCreneau.styles.scss";
import {
  TUserConnected,
  TCurrentExchange,
  TMouqabalaStep,
  TCreneau,
  TCreneauStep,
  TMiniProfil,
  TMemberCurrentExchange,
} from "@/features/profile/types";
import MouqStep3 from "@/features/profile/pages/Exchange-content/components/Echange-Infos/Modals-components/Modal-Mouqabala/Stepper/MouqStep3";
import { InlineIcon } from "@iconify/react";
import { IconButton, Modal, Slide } from "@mui/material";
import MouqCreneauReserved from "@/features/profile/pages/Exchange-content/components/Echange-Infos/Modals-components/Modal-Mouqabala/Stepper/MouqCreneauReserved";

interface ModalCreneauProps {
  open: boolean;
  onClose:
    | ((event: {}, reason: "backdropClick" | "escapeKeyDown") => void)
    | undefined;
  closeClick: () => void;
  currentExchange?: TMemberCurrentExchange | null;
  receiver: TMiniProfil | null;
  mouqabala_id: string;
}
const ModalCreneau = ({
  open,
  onClose,
  closeClick,
  currentExchange,
  receiver,
  mouqabala_id,
}: ModalCreneauProps) => {
  const [step, setStep] = useState<TMouqabalaStep | TCreneauStep>(1);
  const handleBackClick = () => {
    if (step === 1) {
      closeClick();
    } else {
      setStep((prev) => {
        let result = (prev - 1) as 1 | 2;
        return result;
      });
    }
  };
  const [selectedCreneau, setSelectedCreneau] = useState<Partial<TCreneau>>({
    creneau_date: "",
    creneau_start_time: "",
    creneau_end_time: "",
  });

  return (
    <Modal open={open} onClose={onClose} closeAfterTransition>
      <Slide in={open} direction="left" mountOnEnter unmountOnExit>
        <div className=" modal-mouqabala-container">
          <div className=" back">
            <IconButton size="large" color="primary" onClick={handleBackClick}>
              <InlineIcon icon="ion:arrow-back" />
            </IconButton>
          </div>

          <div className=" close">
            <IconButton size="large" color="inherit" onClick={closeClick}>
              <InlineIcon icon="material-symbols:close" />
            </IconButton>
          </div>
          <div className="content">
            <p className="title">
              {" "}
              Organiser une mouqabala avec <span>
                {receiver?.username}
              </span>{" "}
            </p>
            <>
              {step === 1 && (
                <MouqStep3
                  setStep={setStep}
                  close={closeClick}
                  setSelectedCreneau={setSelectedCreneau}
                  receiver={receiver}
                  isFromModalCreneau={true}
                  conversation_id={currentExchange?.conversationId || ""}
                />
              )}
              {step === 2 && (
                <MouqCreneauReserved
                  setStep={setStep}
                  close={closeClick}
                  receiver={receiver}
                  selectedCreneau={selectedCreneau}
                  mouqabala_id={mouqabala_id}
                />
              )}
            </>
          </div>
        </div>
      </Slide>
    </Modal>
  );
};

export default ModalCreneau;
